import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyleWrapper = createGlobalStyle`
  html {
    overflow: hidden;
  }
`;

export const Container = styled.div`
  iframe {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;
